import React, { useEffect, useRef, useState } from 'react';
import './footer-bar.scss';
import { Container, Grid } from '@material-ui/core';

/**
 * Footer bar.
 *
 * This bar will remain sticky (fixed) to the bottom of the screen
 * while the viewport is outside where this element sits (at the bottom).
 */
export const FooterBar: React.FC = (props) => {
  const {
    children,
  } = props;

  const [sticky, setSticky] = useState<boolean>(false);
  const footerRef = useRef<HTMLDivElement>(null);

  /**
   * Observes the div container and sets or unsets the sticky state.
   */
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setSticky(!entry.isIntersecting);
    }, { threshold: 1 });
    observer.observe(footerRef.current as HTMLDivElement);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div
      className="sg-footer-bar"
      ref={footerRef}
    >
      <div className={`footer-container ${sticky ? 'footer-container--sticky' : ''}`}>
        <Container>
          <Grid
            className="button-container"
            justify="space-between"
            container
          >
            {children}
          </Grid>
        </Container>
      </div>
    </div>
  );
};
